// extracted by mini-css-extract-plugin
export default {"technicians":"technician-list_technicians__r9srC"};